import {PageContent} from '@/components/ui/page-atoms/PageAtoms'
import styled from 'styled-components'

export const StyledProjectsRoute = styled(PageContent)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
`
